/**
 * Whether an element may animate right now: in the viewport and in a visible document.
 */
import { computed, ref } from 'vue'
import { useDocumentVisibility, useIntersectionObserver } from '@vueuse/core'
import type { UseIntersectionObserverOptions } from '@vueuse/core'
import type { Ref } from 'vue'

export function useMayAnimate(target: Ref<HTMLElement | null>, options?: UseIntersectionObserverOptions) {
    const isInViewport = ref(false)

    useIntersectionObserver(target, ([entry]) => {
        isInViewport.value = entry?.isIntersecting ?? false
    }, options)

    const documentVisibility = useDocumentVisibility()

    return computed(() => isInViewport.value && documentVisibility.value === 'visible')
}
